import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-by-product-monthlysale',
  templateUrl: './by-product-monthlysale.component.html',
  styleUrls: ['./by-product-monthlysale.component.scss']
})
export class ByProductMonthlysaleComponent implements OnInit {

  register_list = ["Register", "Non-Register"];
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  month_list_for_last_12_months: any = [];
  // register_list: any =[];
  selected_register_for_report: any = null;
  selected_month_for_run: any = null;
  selected_month_for_report: any = null;
  global_config: any;
  selected_run_split: {};
  document_data: any[];
  run_split: any;
  is_document_available: boolean = true;
  pdf_data: any;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  constructor(private httpService: HttpService, private dom: DomSanitizer, private global: GlobalService) {
    let today = new Date();
    this.title = this.global._active_display_name;
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    }
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 11; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
    this.httpService.getGlobalConfigData().subscribe((data) => {
      console.log(data);
      this.global_config = data;
      // this.mobile_number = data['mobile_number'];
    }, (error) => {
      console.error(error);
    });
  }


  getClicked() {
    console.log('get Clicked')
    this.document_file = null;
    let data_dict = {
      'month': this.selected_month_for_report,
      'register_status': this.selected_register_for_report
    }
    console.log(data_dict);
    this.is_document_available = false;
    console.log(data_dict['register_status']);
    if (data_dict['register_status'] == "Register") {
      this.httpService.monthlySaleRegisterReport(data_dict).subscribe((data) => {
        console.log(data);
        if (data == false) {
          alert('Data not available in this months')
          return false
        }
        this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
        this.document_file = data;
        this.is_document_available = true;
      }, (error) => {
        this.is_document_available = true;
      });
    }
    else {
      console.log('non-register')
      this.httpService.monthlySaleNonRegisterReport(data_dict).subscribe((data) => {
        console.log(data);
        if (data == false) {
          alert('Data not available in this months')
          return false
        }
        this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
        this.document_file = data;
        this.is_document_available = true;
      }, (error) => {
        this.is_document_available = true;
      });
    }
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
